module.exports = __webpack_public_path__ + "img/adblock.0eee3a1b.jpg";